/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { RESOURCE_TYPES } from "@adapptio/lib-core";

import { IEditor } from "../../IEditor";
import { ActionEditorView } from "./ActionEditorEdit/ActionEditorView";
import { ActionEditorEditMain } from "./ActionEditorEdit/components/ActionEditorEditMain";
import { registerCommands } from "./Commands";
import { registerKeyBindings } from "./KeyBindings";
import { registerMenus } from "./Menus";

export function ActionEditorModule(dc: IEditor): void {
	dc.get("logger").debug("Action Editor module enabled.");

	const resourceSvc = dc.get("resourceService");
	const viewSvc = dc.get("viewService");

	viewSvc.registerView("actionEditor.edit", ActionEditorView, ActionEditorEditMain);

	resourceSvc.registerResourceView(RESOURCE_TYPES.ACTION, "actionEditor.edit");
	resourceSvc.registerResourceCreateCommand(RESOURCE_TYPES.ACTION, "actionEditor.create.open");

	registerCommands(dc);
	registerKeyBindings(dc);
	registerMenus(dc);
}
